import graphql from 'graphql-tag'
import api from '@stores/apollo'

export default function updateMany({
  ids,
  changes,
}: {
  ids: string[]
  changes: {
    color?: string
    hidden?: boolean
  }
}) {
  return api.gql.mutate({
    mutation,
    variables: {
      input: {
        data: changes,
        where: {
          OR: ids.length > 1 ? ids.map((id) => ({ id })) : undefined,
          id: ids.length === 1 ? ids[0] : undefined,
        },
      },
    },
  })
}

const mutation = graphql`
  mutation updateManyDepartments($input: UpdateManyDepartmentsInput!) {
    updateManyDepartments(input: $input) {
      departments {
        id
      }
    }
  }
`
